import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'
import { auth2,ref2 } from '../config/firebase2'
import ReactTable from 'react-table'
import "react-table/react-table.css";

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';


class ViewUser extends Component {

	constructor(){
        super();
            this.redirect = this.redirect.bind(this)
            this.removeUser = this.removeUser.bind(this);
            this.state = {
              userId : "",
              user : {},
              userList:{}
            };
    }

    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                db.on("value",function(data){

                    this.setState({
                    userId:data.key,
                    user:data.val()
                    });

                }.bind(this));
            }else{
            this.props.history.push("/");
            }
        });

        var list = ref.child('users').orderByChild('status').equalTo('Active');
        list.on("value", function(data){
            
                this.setState({
                userList : data.val()
                })
            
        }.bind(this))
    } 



    componentWillUnmount(){
      this.listener()
    } 

    redirect(id){
        window.location.assign("/users/"+id+"/edit")
    }

    removeUser(id){

        let userInfo = this.state.userList
        let userData = {}
        if(window.confirm("Are you sure you want to delete this user")===true){
            Object.keys(userInfo).map(key => {
                userData = userInfo[id]
                if(userData===userInfo[key]){
                    auth2.signInWithEmailAndPassword(userData.email,userData.password)
                    auth2.onAuthStateChanged(userlog=>{
                        if(userlog){
                            let user = auth2.currentUser
                            if(user){
                                user.delete().then(function(){
                                    let statusUpdate={
                                        status: "Inactive"
                                    }
                                    ref2.child("users").child(id).update(statusUpdate).then(()=>{
                                        alert("User successfully deleted ")
                                    window.location.assign("/")
                                    })                             
                                })
                            }else{
                            alert("error deleting users")
                            }
                        }// end of condition userlog
                    })// end of authstatechanged
                }// end of condition userdata = userinfo[key]
            })//end of loop
        }// end of window confirm 
    }


    render() {
         var x = [];
        this.state.userList &&
        Object.keys(this.state.userList).map(key => {
            let list = this.state.userList[key]
                list.id = key
                list.firstname = list.firstname.toUpperCase();
                list.lastname = list.lastname.toUpperCase();
                list.gender = list.gender.toUpperCase();
                list.role = list.role.toUpperCase();
            x.push(list)
            }) 
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content" className="forViewUser">
                            <Title title="View Users" />
                            <div className="block">
                                <ReactTable
                                        data={x}
                                        columns={[
                                            {
                                                Header: "Email Address",
                                                accessor : "email",
                                                filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id]).includes(filter.value) : true
                                                                  },
                                            },
                                            {
                                                Header: "First Name",
                                                accessor : "firstname",
                                                filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                            },
                                            {
                                                Header: "Last Name",
                                                accessor : "lastname",
                                                filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                            },
                                            {
                                                Header: "Gender",
                                                accessor : "gender",
                                                filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                            },
                                            {
                                                Header: "Role",
                                                accessor : "role",
                                                filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },

                                            },
                                            {
                                                Header: 'Action',
                                                accessor : "id",
                                                Cell : row => (
                                                    <span><button onClick={()=>this.redirect(row.value)}><i className="fa fa-pencil"></i></button>
                                                    <button onClick={()=>this.removeUser(row.value)}><i className="fa fa-times"></i></button></span>
                                                )
                                                                                   
                                            }
                                        ]}
                                        
                                        filterable ={true}
                                        defaultPageSize={10}
                                        className="-striped -highlight"
                                    />   
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
      
        );
    }
}

export default ViewUser;



// WEBPACK FOOTER //
// ./src/components/ViewUser.js